export const flexRow = `
display:flex;
flex-direction:row;
`;
